import NavSideBar from "../component/NavSideBar";

export default function Colors() {
  return (
    <NavSideBar>
        <div className="p-10 text-3xl font-bold">Colors</div>
    </NavSideBar>
  )
}
